interface FinalCTAProps {
  scrollToForm?: () => void;
}

export default function FinalCTA({ scrollToForm }: FinalCTAProps) {
  const handleClick = () => {
    if (scrollToForm) {
      scrollToForm();
    }
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-28 bg-[#E91E63]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Diga adeus aos pelos e à foliculite!
        </h2>

        <p className="text-lg sm:text-xl text-white/90 mb-6">
          Comece hoje a sua transformação e sinta a liberdade de uma pele lisa todos os dias.
        </p>

        <p className="text-base sm:text-lg text-white/90 mb-8">
          Na <span className="font-bold">GIO Estética Avançada – Paulínia</span> você faz depilação com o melhor laser do mundo, tecnologia da Grife italiana <span className="font-semibold">Quanta Systems</span>, que proporciona:
        </p>

        <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-10">
          <div className="flex items-center justify-center gap-2 text-white">
            <span className="text-xl">✨</span>
            <span className="font-medium">Resultados rápidos</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-white">
            <span className="text-xl">✨</span>
            <span className="font-medium">Mais conforto durante a sessão</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-white">
            <span className="text-xl">✨</span>
            <span className="font-medium">Segurança para diversos tipos de pele</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-white">
            <span className="text-xl">✨</span>
            <span className="font-medium">Redução definitiva dos pelos</span>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={handleClick}
          className="bg-[#16A34A] hover:bg-[#15803D] text-white font-bold text-base sm:text-lg px-8 sm:px-10 py-4 sm:py-5 rounded-2xl transition-all duration-300 hover:scale-105 shadow-xl shadow-black/20 cursor-pointer"
        >
          Agendar Três Sessões Grátis
        </button>
      </div>
    </section>
  );
}
